// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/InventoryPeriodClose.yaml
// Generated: 2026-01-22T15:19:14.157Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateInventoryPeriodClose, UpdateInventoryPeriodClose, InventoryPeriodClose } from '@/types/inventory/InventoryPeriodClose';

/**
 * InventoryPeriodClose Service
 * CRUD operations for InventoryPeriodClose via the ABP API.
 */
export const inventoryPeriodCloseService = new EntityService<InventoryPeriodClose, CreateInventoryPeriodClose, UpdateInventoryPeriodClose>(
  '/api/inventory/inventoryperiodclose',
  'InventoryPeriodClose',
);
